(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:HistoricoAdubacaoCtrl
   * @description
   * # HistoricoAdubacaoCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('HistoricoAdubacaoCtrl', HistoricoAdubacaoCtrl);

  HistoricoAdubacaoCtrl.$inject = [
    '$scope',
    '$rootScope',
    'LoadingService',
    'PeriodSelectService',
    'filterFilter',
    'HistoricosService',
    'MessagesService',
    'AdubacoesService',
    '$q',
    'RecomendacoesService',
    'MapaService',
    '$http',
    'GoogleMapsService',
    'PeriodosService',
    'DrawPolygonsObjectService',
    '$route',
    '$routeParams',
    'LeafletService',
    'TrackingService',
    'AplicacoesService',
    '$anchorScroll',
    'DecimalsService'
  ];

  /* eslint-disable-next-line max-lines-per-function, max-params */
  function HistoricoAdubacaoCtrl($scope, $rootScope, LoadingService, PeriodSelectService, filterFilter,
    HistoricosService, MessagesService, AdubacoesService, $q, RecomendacoesService, MapaService, $http,
    GoogleMapsService, PeriodosService, DrawPolygonsObjectService, $route, $routeParams, LeafletService,
    TrackingService, AplicacoesService, $anchorScroll, DecimalsService) {
    let hasPage = true;
    let inProgress = true;
    let requestId = 0;
    let percentualRecomendadoAplicado;
    let activePolygons = [];

    //////////////////////////////////////////
    // Controller data
    $scope.initialized = false;
    $scope.glebas = $rootScope.currentPropriedade.glebas || [];
    $scope.applications = [];
    $scope.adubacoesFilters = {};
    $scope.filtroPeriodo = {};
    $scope.loadingAplicacoes = false;
    $scope.statusFilter = { integrado: false, erro: false, pendente: false };

    //////////////////////////////////////////
    // Bindable methods
    $scope.initializeVariables = initializeVariables;
    $scope.initialize = initialize;
    $scope.resetPeriodsFilter = resetPeriodsFilter;
    $scope.setValoresComBaseNoHistorico = setValoresComBaseNoHistorico;
    $scope.getApplications = getApplications;
    $scope.openApplicationDetail = openApplicationDetail;
    $scope.getSubCardApplicationId = getSubCardApplicationId;
    $scope.getCardApplicationId = getCardApplicationId;
    $scope.setPositionSubCardAdubacao = setPositionSubCardAdubacao;
    $scope.setClassificacaoAplicadoRecomendado = setClassificacaoAplicadoRecomendado;
    $scope.openRecommendationDetail = openRecommendationDetail;
    $scope.isOpened = isOpened;
    $scope.getRecommendationDataInicio = getRecommendationDataInicio;
    $scope.getRecommendationDataFim = getRecommendationDataFim;
    $scope.canManage = canManage;
    $scope.showRastroMaquina = showRastroMaquina;
    $scope.showAreaDemarcada = showAreaDemarcada;
    $scope.setFilterAttribute = setFilterAttribute;
    $scope.setPeriodo = setPeriodo;
    $scope.openPeriodsFilter = openPeriodsFilter;
    $scope.toggleStatusFilter = toggleStatusFilter;
    $scope.getStatusFilterLabel = getStatusFilterLabel;
    $scope.remover = remover;
    $scope.getRecommendationProducts = getRecommendationProducts;
    $scope.calculateTotalProduto = calculateTotalProduto;
    $scope.edit = edit;

    //////////////////////////////////////////
    // Function declarations

    function initializeVariables() {
      $scope.adubacoesFilters.page = 1;
      hasPage = true;
      inProgress = false;
      requestId += 1;
      $scope.applications = [];
      percentualRecomendadoAplicado = $rootScope.parametros.percentual_recomendado_aplicado ||
        PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO;
    }

    function initialize() {
      if (!$scope.initialized) {
        $scope.initialized = true;
        $scope.loadingAplicacoes = true;
        $scope.adubacoesFilters = {
          tipo: 'adubacao'
        };

        $scope.initializeVariables();
        $scope.resetPeriodsFilter();
        $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
        $scope.setValoresComBaseNoHistorico();

        loadData();

        const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
        if (selectedGleba) {
          $scope.adubacoesFilters.gleba = $scope.$root.currentPropriedade.glebas
            .find((gleba) => gleba.id === +selectedGleba);
        }

        $scope.getApplications();
        AplicacoesService.closeOpenRecommendationsModal(closeRecommendations);
      }
    }

    function loadData() {
      $scope.loadingGrupoInsumo = true;

      PeriodosService.list().then(function(result) {
        $scope.epocas = result.data;
      }, function(error) {
        console.error('Erro ao listar períodos das culturas', error);
      });

      HistoricosService.listGruposInsumos()
        .then(function(data) {
          $scope.filtroGruposInsumos = data.data || [];
        })
        .catch(function() {
          MessagesService.alert('Não foi possível consultar os dados.');
        })
        .finally(function() {
          $scope.loadingGrupoInsumo = false;
        });
    }

    function setValoresComBaseNoHistorico() {
      let filteredPeriod;

      if ($routeParams.date || $routeParams.historyDate) {
        filteredPeriod = HistoricosService.getFilteredPeriod();
        $scope.adubacoesFilters.dataInicial = filteredPeriod.dataInicial;
        $scope.adubacoesFilters.dataFinal = filteredPeriod.dataFinal;
        $scope.period = filteredPeriod.periodo;
      }
      if ($routeParams.activeGleba) {
        $scope.adubacoesFilters.gleba = filterFilter($scope.glebas, { id: +$routeParams.activeGleba }, true)[0];
      }
    }

    function resetPeriodsFilter() {
      $scope.adubacoesFilters.dataInicial = null;
      $scope.adubacoesFilters.dataFinal = null;
      $scope.period = {
        eventDates: [],
        periodo: ''
      };
    }

    function getApplications() {
      const hasFilterPage = $scope.adubacoesFilters && $scope.adubacoesFilters.page;

      if (hasFilterPage && hasPage && !inProgress) {
        inProgress = true;
        $scope.loadingAplicacoes = true;

        const promises = [
          AdubacoesService.list($scope.adubacoesFilters)
        ];

        if (!$scope.applications.length) {
          promises.push(AdubacoesService.getStatusAdubacaoGlebas($scope.adubacoesFilters));
        }

        processApplications(promises, requestId);
      }
    }

    // eslint-disable-next-line max-lines-per-function
    function processApplications(promises, currentRequestId) {
      $q.all(promises)
        .then(function(data) {
          if (currentRequestId !== requestId) {
            return;
          }
          const dados = data[0].data || [];
          hasPage = _.get(data[0], 'pages.pagination.next', 0) > $scope.adubacoesFilters.page;

          if (dados.length > 0) {
            $scope.adubacoesFilters.page++;
            $scope.applications = $scope.applications.concat(dados);
            closeApplicationsAreaVisivel();
            clearMapPolygons();

            if ($scope.applications.length === 1) {
              $scope.openApplicationDetail(null, $scope.applications[0]);
            } else if ($routeParams.activeApplication) {
              const app = $scope.applications.find(function(a) {
                return +a.id === +$routeParams.activeApplication;
              });
              if (app) {
                $scope.openApplicationDetail(null, app);
              } else {
                updateRouteParams();
              }
            }
          }
        })
        .catch(() => {
          if (currentRequestId === requestId) {
            MessagesService.alert('Não foi possível buscar a lista de adubações.');
          }
        })
        .finally(function() {
          if (currentRequestId === requestId) {
            inProgress = false;
            $scope.loadingAplicacoes = false;
          }
        });
    }

    function getById(adubacao) {
      updateRouteParams(adubacao.id);
      adubacao.loading = true;
      adubacao.allData = {};
      AdubacoesService.get(adubacao.id)
        .then(({ data }) => {
          adubacao.allData = data || {};
          $anchorScroll($scope.getCardApplicationId(data));
        })
        .catch(() => MessagesService.alert('Não foi possível consultar a adubação.'))
        .finally(() => {
          adubacao.loading = false;
          adubacao.open = true;
        });
    }

    function openApplicationDetail(event, adubacao) {
      if (event) {
        stopPropagation(event);
        preventDefault(event);
      }

      if (!adubacao || !adubacao.id) {
        return;
      }

      clearMapPolygons();
      closeApplicationsAreaVisivel();
      adubacao.openRecommendation = false;
      adubacao.classificacao = {};

      if (!adubacao.open) {
        getById(adubacao);
      } else {
        adubacao.open = false;
        updateRouteParams();
      }
    }

    function updateRouteParams(id = null) {
      $route.updateParams({
        activeApplication: id
      });
    }

    function openRecommendationDetail(event, adubacao) {
      stopPropagation(event);
      preventDefault(event);

      if (!adubacao || !adubacao.id || !adubacao.open) {
        return;
      }

      if (!adubacao.openRecommendation) {
        adubacao.openRecommendation = !adubacao.openRecommendation;
        adubacao.recommendation = {};
        $scope.setPositionSubCardAdubacao(adubacao);

        if (_.get(adubacao, 'allData.atributo.recomendacao_id')) {
          adubacao.loadingRecommendation = true;
          loadRecomendacao(adubacao);
        }
      } else {
        adubacao.openRecommendation = !adubacao.openRecommendation;
      }
    }

    function loadRecomendacao(adubacao) {
      RecomendacoesService.getAdubacao(adubacao.allData.atributo.recomendacao_id)
        .then(function(data) {
          adubacao.recommendation = data.data || {};
          adubacao.recommendation.gleba = filterFilter(adubacao.recommendation.glebas, {
            gleba: { id: adubacao.gleba.id }
          })[0];
          $scope.setClassificacaoAplicadoRecomendado(adubacao);
        })
        .catch((e) => {
          MessagesService.alert('Não foi possível consultar a recomendação.');
          console.error('Erro ao consultar recomendação', e);
        })
        .finally(() => {
          adubacao.loadingRecommendation = false;
        });
    }

    function setPositionSubCardAdubacao(adubacao) {
      const card = $(`#${$scope.getCardApplicationId(adubacao)}`);
      const subCard = $(`#${$scope.getSubCardApplicationId(adubacao)}`);

      subCard.css({
        'min-height': `${card.height()}px`,
        width: `${card.width()}px`,
        top: `${card.offset().top}px`
      });
    }

    function getSubCardApplicationId(adubacao) {
      return `subcard-adubacao-${adubacao.id}`;
    }

    function getCardApplicationId(adubacao) {
      return `adubacao-${adubacao.id}`;
    }

    /* eslint-disable max-len,no-mixed-operators */
    function setClassificacaoAplicadoRecomendado(adubacao) {
      function getExisteDiferencaDoseRecomendadoAplicado(recomendado, aplicado) {
        return !recomendado.produto || Math.abs(aplicado.qt_dose * 100 / recomendado.qt_dose - 100) > percentualRecomendadoAplicado;
      }

      if (adubacao.recommendation) {
        adubacao.classificacao = {
          area: adubacao.area !== adubacao.recommendation.gleba.area_recomendada,
          dtIni: adubacao.dt_ini < adubacao.recommendation.data_inicio ||
                adubacao.dt_ini > adubacao.recommendation.data_termino,
          dtFim: adubacao.dt_fim < adubacao.recommendation.data_inicio ||
                adubacao.dt_fim > adubacao.recommendation.data_termino,
          velocidadeVento: +adubacao.recommendation.parametro.velocidade_maxima_vento < +adubacao.allData.atributo.velocidade_maxima_vento
        };
        adubacao.classificacao.itensAplicacao = adubacao.allData.itens.map(function(produto) {
          const produtoRecomendacao = filterFilter(adubacao.recommendation.produtos, { produto: { item_id: produto.item_codigo } }, true)[0] || {};

          return {
            produto: !(produtoRecomendacao.produto || {}).item_id,
            dose: getExisteDiferencaDoseRecomendadoAplicado(produtoRecomendacao, produto)
          };
        });

        adubacao.classificacao.insumosRecomendacao = adubacao.recommendation.produtos.map(function(produto) {
          const produtoAplicado = filterFilter(adubacao.allData.itens, { item_codigo: produto.produto.item_id }, true)[0] || {};
          return {
            produto: !produtoAplicado.item_codigo,
            aplicado: AplicacoesService.getAppliedPercentage(adubacao.recommendation, produto, produtoAplicado)
          };
        });
      }
    }
    /* eslint-enable */

    function isOpened(adubacao) {
      return adubacao.open && adubacao.openRecommendation;
    }

    function getRecommendationDataInicio(adubacao) {
      return adubacao.recommendation.data_inicio;
    }

    function getRecommendationDataFim(adubacao) {
      return adubacao.recommendation.data_termino;
    }

    function canManage(aplicacao) {
      const aplicacaoProcessada = aplicacao && aplicacao.situacao !== 'pendente';
      const { adubacao } = $rootScope.permissions;

      return adubacao.canManage && adubacao.canEditDelete && aplicacaoProcessada;
    }

    function showAreaDemarcada(adubacao) {
      if (!adubacao.areaVisivel) {
        adubacao.areaVisivel = true;

        if (adubacao.allData.has_area_demarcada) {
          adubacao.polygons = DrawPolygonsObjectService
            .convertToObject(adubacao.allData.area_demarcada || {}, true)
            .polygons;

          // Utilizado weight pois este polígono é montado pelo leafletjs
          // https://leafletjs.com/reference-1.2.0.html#polygon
          adubacao.polygons.forEach(({ options }) => {
            options.weight = 7;
            options.strokeWeight = 7;
          });

          activePolygons = activePolygons.concat(adubacao.polygons);
          $scope.$emit('addPolygons', adubacao.polygons);
          const map = LeafletService.getMap('propriedade-map');
          map.fitBounds(adubacao.polygons.map(function(polygon) {
            return polygon.getBounds();
          }));
        }
      } else {
        clearMapPolygons();
        adubacao.areaVisivel = false;
      }
    }

    function activeHeatmaps(adubacao) {
      const { polylines } = adubacao;

      if (!polylines.length) {
        return [];
      }

      $route.updateParams({
        heatmaps: 'pulverizacao'
      });
      $scope.$emit('setActiveHeatmaps', {
        heatmaps: [{ ...adubacao, title: 'Aplicação de adubação visível' }],
        mapType: 'aplicacao'
      });

      const start = polylines[0].coordinate;
      const end = polylines[polylines.length - 1].coordinate;
      const startEndMarkers = MapaService.createStartEndMarkers(start, end);
      $scope.$emit('setMarkers', startEndMarkers);
      renderPolylines(adubacao.polylines);
    }

    function getPolylines(data, adubacao) {
      const polylines = MapaService.getLeafletPolylineWithObject({
        pontos: data,
        faixas: adubacao.allData.faixas_velocidade
      });
      polylines.forEach((polyline) => {
        polyline.decorator = L.polylineDecorator(polyline, {
          patterns: [
            {
              offset: 20,
              repeat: 50,
              symbol: L.Symbol.arrowHead({
                pixelSize: 7,
                polygon: false,
                pathOptions: {
                  stroke: true,
                  color: polyline.options.color
                }
              })
            }
          ]
        });
      });

      return polylines;
    }

    function showRastroMaquina(adubacao) {
      $scope.$emit('clearHeatMap');
      $http.get(`${SERVER}v1/aplicacoes/${adubacao.id}/tracking`).then(function({ data }) {
        if (data.length > 0) {
          adubacao.polylines = getPolylines(data, adubacao);
          activeHeatmaps(adubacao);
        } else {
          adubacao.polylines = [];
        }
      });
    }

    function renderPolylines(polylines) {
      $scope.$emit('setPolylines', polylines);
      const map = LeafletService.getMap('propriedade-map');
      polylines.forEach((polyline) => {
        polyline.decorator.addTo(map);
      });
      map.fitBounds(polylines.map(function(polyline) {
        return polyline.getBounds();
      }));

      polylines.forEach(function(polyline) {
        polyline.bindPopup(createInfoWindow(null, polyline));
      });
    }

    function setFilterAttribute(attribute, object, event) {
      preventDefault(event);
      $scope.initializeVariables();
      $scope.adubacoesFilters[attribute] = object;
      $scope.getApplications();
    }

    function openPeriodsFilter(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection($scope.period, $scope.adubacoesFilters).then(function() {
        $scope.setPeriodo();
      });
    }

    function toggleStatusFilter(status, event) {
      stopPropagation(event);
      preventDefault(event);
      $scope.statusFilter[status] = !$scope.statusFilter[status];
      $scope.initializeVariables();
      $scope.adubacoesFilters.status = buildStatusParam($scope.statusFilter);
      $scope.getApplications();
    }

    function getStatusFilterLabel() {
      const statusLabels = { integrado: 'Integrado', erro: 'Erro', pendente: 'Pendente' };
      const chaves = Object.keys(statusLabels);
      const selecionadas = chaves.filter((chave) => $scope.statusFilter[chave]);

      if (selecionadas.length === 0 || selecionadas.length === chaves.length) {
        return 'Status';
      }
      return selecionadas.map((chave) => statusLabels[chave]).join(', ');
    }

    function buildStatusParam(statusFilter) {
      const statusParaApi = { integrado: 'finalizado', erro: 'erro', pendente: 'pendente' };
      const selecionadas = Object.keys(statusParaApi).filter((chave) => statusFilter[chave]);
      return selecionadas.length ? selecionadas.map((chave) => statusParaApi[chave]).join(',') : null;
    }

    function setPeriodo(periodo, event) {
      preventDefault(event);
      $scope.initializeVariables();
      if (periodo) {
        $scope.adubacoesFilters.dataInicial = periodo.dataInicial;
        $scope.adubacoesFilters.dataFinal = periodo.dataFinal;
        $scope.period.periodo = periodo.descricao;
      }
      $scope.getApplications();
    }

    function remover(adubacao) {
      MessagesService.confirm('Deseja realmente excluir a adubação?')
        .then(function() {
          LoadingService.showLoading();
          AdubacoesService.delete(adubacao.id)
            .then(function() {
              MessagesService.alert('Adubação excluída com sucesso.');
              $route.reload();
            })
            .catch(function(error) {
              let message = 'Falha ao excluir adubação';
              if (_.get(error.data, 'message')) {
                message = `${message}: ${error.data.message}`;
              }
              MessagesService.alert(message);
              console.error('Falha ao excluir adubação', error);
            })
            .finally(LoadingService.hideLoading);
        });
    }

    function calculateTotalProduto(produto, areaGleba, shouldRecalculate) {
      const dose = produto.dose || produto.qt_dose;
      const quantidadeTotal = dose * areaGleba;

      if (DecimalsService.isDecimalV2Enabled()) {
        const quantidadeTotalProduto = Math.max(+produto.qt_total, 0) > 0 && !shouldRecalculate ?
          +produto.qt_total :
          quantidadeTotal;

        return DecimalsService.formatDoseOrQuantityForDisplay(quantidadeTotalProduto);
      }

      return quantidadeTotal;
    }

    function getRecommendationProducts(adubacao) {
      return (adubacao.recommendation || {}).produtos;
    }

    function createInfoWindow(event, polygon) {
      const content = TrackingService.getContentInfoWindow(polygon);
      return `<div class="simple-popup">
                ${content}
              </div>`;
    }

    function edit(application) {
      $scope.$emit('activateSidebar', 'editApplication', application);
    }

    function closeRecommendations() {
      ($scope.applications || []).forEach(function(application) {
        application.openRecommendation = false;
      });
      $scope.$apply();
    }

    function clearMapPolygons() {
      if (activePolygons.length > 0) {
        $scope.$emit('removePolygons', activePolygons);
        activePolygons = [];
      }
    }

    function closeApplicationsAreaVisivel() {
      $scope.applications.forEach((aplicacao) => {
        if (aplicacao.areaVisivel) {
          aplicacao.areaVisivel = false;
        }
      });
    }

    function filterHasChanges() {
      const { gleba, dataInicial } = $scope.adubacoesFilters;
      const { activeGleba, historyDate } = $routeParams;

      const filterGlebaChanged = activeGleba && +activeGleba !== (gleba || {}).id;
      const filterDateChanged = historyDate && historyDate !== dataInicial;

      return !!(filterGlebaChanged || filterDateChanged);
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$on('adubacaoActivate', $scope.initialize);

    $scope.$on('$destroy', () => {
      clearMapPolygons();
      closeApplicationsAreaVisivel();
    });

    $scope.$on('applications_close', function() {
      $scope.applications = [];
    });

    $scope.$on('$routeUpdate', function() {
      if ($scope.adubacoesFilters) {
        if (filterHasChanges()) {
          initializeVariables();
          setValoresComBaseNoHistorico();
          $scope.getApplications();
        }
      }

      if ($routeParams.activeApplicationsTab !== 'adubacao' && activePolygons.length > 0) {
        clearMapPolygons();
        closeApplicationsAreaVisivel();
      }
    });
  }
}());
